/** @jsxImportSource @emotion/react */
import { useEffect, useRef, useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import "twin.macro";
import tw from "twin.macro";

export const getShortPosition = (position) => {
  switch (position.toLowerCase()) {
    case "frontleft":
      return "FL";
    case "frontright":
      return "FR";
    case "rearleft":
      return "RL";
    case "rearright":
      return "RR";
    default:
      return "";
  }
};

const FileSelector = ({ file }) => {
  const { control, setValue } = useFormContext();
  const selectedFiles = useWatch({
    control,
    name: "selectedFiles",
    defaultValue: { dat: [], dxp: [] },
  });
  const checkboxRef = useRef(null);
  const [, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true); // force rerender après montage pour afficher correctement les checkbox des fichiers selectionnés
  }, []);

  if (!file) return null;

  const checked = Object.values(selectedFiles).some((files) =>
    files.some((f) => f.name === file.name),
  );
  const type = file.name?.toLowerCase().endsWith(".dat") ? "dat" : "dxp";

  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setValue("fileSelectionToggle", {
      name: file.name,
      oid: file.oid,
      file: file, // Keep the full file object for later use,
      position: getShortPosition(file.position ?? ""),
      type: type,
      deltaP: file.deltaP ?? 0,
      userMargins: file.userMargins,
      methodMargins: file.methodMargins,
    });
  };

  return (
    <div
      onClick={(event) => handleClick(event)}
      className="group"
      css={[
        tw`flex flex-shrink mx-auto items-center gap-2 text-sm border bg-opacity-50 rounded-md py-1 px-2 hover:border-gray-300 hover:bg-opacity-100 cursor-pointer`,
        checked ? tw`bg-indigo-100 border-indigo-200` : tw`bg-gray-100 border-gray-200`,
      ]}
    >
      <input
        type="checkbox"
        ref={checkboxRef}
        css={[
          tw`bg-gray-100 bg-opacity-50 z-30 ring ring-transparent ring-offset-4 ring-offset-gray-100 focus:(ring-gray-100) h-4 w-4 text-indigo-600 border-gray-300 rounded`,
          checked
            ? tw`ring-offset-indigo-100`
            : tw`ring-offset-gray-100 group-hover:border-gray-400`,
        ]}
        checked={checked}
        readOnly
      />
      <div>{file.name}</div>
    </div>
  );
};

export default FileSelector;
